<template>
    <div id="result-sidebar-menu" class="sidebar-menu-container">
<!--        <div class="project-preview-sidebar">-->
<!--            <img class="project-preview-image" :src="urlForStatic('/img/projectPreviewsDemo/house3.jpg')"/>-->
<!--            <div class="project-preview-text-container collapsable-ellipsis">-->
<!--                <span class="project-preview-text">Дачный дом</span>-->
<!--            </div>-->
<!--        </div>-->
        <div class="sidebar-main-label">Сумма заказа</div>
        <div v-if="priceLoaded">
            <div class="sidebar-characteristics-text">
                <span class="characteristics-name">Всего товаров</span>
                <span class="bold-text characteristics-val">{{numberProducts}}</span>
            </div>
            <template v-for="product in productsCost">
                <div class="sidebar-characteristics-text">
                    <span class="characteristics-name">{{product.name}}</span>
                    <span class="bold-text characteristics-val">{{product.cost.toString().replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, ' ')}} ₽</span>
                </div>
            </template>
            <div class="sidebar-characteristics-text">
                <span class="characteristics-name">Общая стоимость</span>
                <span class="bold-text characteristics-val">{{totalCost}} ₽</span>
            </div>
        </div>
        <div v-else>
            <div class="sidebar-spinner-container">
                <div class="sidebar-spinner-grid">
                    <div class="sidebar-spinner">
                        <SpinnerTwo/>
                    </div>
                    <div class="sidebar-spinner-text">Идёт расчёт стоимости..</div>
                </div>
            </div>
        </div>

<!--        <div class="red-pill-button-of-hate" v-on:click="doCheckout">Оформить заказ</div>-->
        <div class="wide-result-button top-rounding bot-rounding" v-on:click="createPDF()">
            <SVGPrint class="svg-print"/>
            <span class="wide-result-button-text">Распечатать ваш заказ</span>
        </div>
<!--        <div class="wide-result-button bot-rounding">-->
<!--            <SVGDocument/>-->
<!--            <span class="wide-result-button-text">Отправить заказ на email</span>-->
<!--        </div>-->
<!--        <div class="grey-outline-pill-button" v-on:click="editProject">Редактировать проект</div>-->
    </div>
</template>

<script>
    import SVGPrint from "../../SVG/SVGPrint";
    import SVGDocument from "../../SVG/SVGDocument";
    import {urlForStaticVue} from "../../common";
    import {loadResultPDF} from "../../../reportGenerator/createPdf";
    import SpinnerTwo from "../../SpinnerTwo";
    // import {renderDesign} from "../../../fabric/libs/renderDesign";

    export default {
        name: "ResultSidebarMenu",
        mixins: [urlForStaticVue],
        components: {
            SpinnerTwo,
            SVGDocument,
            SVGPrint
        },
        data(){
          return {
              photos: {},
          }
        },
        mounted() {
            this.$store.dispatch('cost/GET_COST');
        },
        computed:{
            priceLoaded() {
                return !this.$store.state.cost.calculationInProgress;
            },
            productsCost(){
                return this.$store.getters["cost/PRODUCTS_COST"];
            },
            totalCost(){
                let totalCost = 0;
                for(let product of this.productsCost){
                    if(typeof product.cost === 'number')
                    totalCost += product.cost;
                }
                return totalCost.toString().replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, ' ');
            },
            numberProducts(){
                return this.productsCost.length;
            }
        },
        methods: {
            doCheckout() {

            },
            editProject() {

            },
            async createPDF() {
                // let promises = [];
                // for (let photoID in this.$store.getters["active/GET_ALL_PHOTO"]){
                //     const promise = new renderDesign(this.$route.params.designID, photoID,5).then((designImg)=>{
                //         setTimeout(()=>{
                //             this.photos[photoID] = designImg;
                //         }, 100)
                //     });
                //     promises.push(promise);
                //     this.$store.dispatch('IN_PROGRESS', promise);
                // }
                // await Promise.all(promises);
                if(!this.$store.state.resultImg.allUploaded){
                    alert('Дождитесь загрузки изображений ...');
                    return;
                }
                const photos = await this.$store.dispatch("resultImg/GET_UPLOADED_PHOTOS_BASE64", {
                  idsPhotos: Object.keys(this.$store.getters["active/GET_ALL_PHOTO"]),
                  idsDesigns: [this.$store.state.route.params.designID]
                });
                const promisePDF = loadResultPDF(this.$store.getters["cost/PRODUCTS_COST"], photos);
                await this.$store.dispatch('IN_PROGRESS', promisePDF);
            }
        }
    }
</script>

<style scoped>
    @media screen and (max-height: 800px) {
        .wide-result-button {
            font-size: 14px;
        }
        .svg-print {
            width: 20px;
            height: 20px;
            margin: auto;
        }
        .sidebar-characteristics-text {
            font-size: 12px;
        }

        .sidebar-spinner-text {
            font-size: 14px;
        }
    }

    @media screen and (min-height: 800px) {
        .wide-result-button {
            font-size: 16px;
        }
        .svg-print {
            margin: auto;
        }
    }

    .wide-result-button {
        border: 2px solid #F2F2F2;
        display: grid;
        grid-template-columns: auto auto;
        grid-column-gap: 5px;
        padding: 15px 10px;
        color: #939393;
        /*font-size: 18px;*/
        cursor: pointer;
        user-select: none;
        text-align: center;
    }

    .wide-result-button:hover {
        background-color: #F2F2F2;
    }

    .wide-result-button:active {
        background-color: unset;
    }

    .wide-result-button-text {
        margin-top: 2px;
        color: #303030;
    }

    .top-rounding {
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        border-bottom: 1px solid #F2F2F2;
        margin-top: 20px;
    }

    .bot-rounding {
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
        border-top: 1px solid #F2F2F2;
        margin-bottom: 20px;
    }

    .sidebar-characteristics-text {
        display: grid;
        grid-template-columns: auto auto;
        grid-column-gap: 5px;
        margin: 20px 0;
    }

    .characteristics-name {
        display: flex;
        justify-content: flex-start;
    }

    .characteristics-val {
        display: flex;
        justify-content: flex-end;
    }

    .bold-text {
        font-weight: bold;
    }

    .sidebar-spinner-container {
        margin-top: 20px;
        width: 100%;
        height: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .sidebar-spinner-grid {
        display: grid;
        grid-template-columns: 40px auto;
        grid-column-gap: 20px;
    }

    .sidebar-spinner {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 50px;
        height: 50px;
    }

    .sidebar-spinner-text {
        display: flex;
        justify-content: center;
        align-items: center;
    }

</style>
